"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDateFilterOptions = exports.isUiRelativeDateFilterForm = exports.isRelativeDateFilterOption = exports.isAbsoluteDateFilterOption = exports.filterVisibleDateFilterOptions = exports.DateFilterHelpers = exports.DateFilter = void 0;
// (C) 2007-2021 GoodData Corporation
var i18n_1 = require("./constants/i18n");
var config_1 = require("./constants/config");
var OptionValidation_1 = require("./validation/OptionValidation");
var AFMConversions_1 = require("./utils/AFMConversions");
var PeriodExclusion_1 = require("./utils/PeriodExclusion");
var OptionUtils_1 = require("./utils/OptionUtils");
Object.defineProperty(exports, "filterVisibleDateFilterOptions", { enumerable: true, get: function () { return OptionUtils_1.filterVisibleDateFilterOptions; } });
var DateFilterTitle_1 = require("./utils/Translations/DateFilterTitle");
var DateFilter_1 = require("./DateFilter");
Object.defineProperty(exports, "DateFilter", { enumerable: true, get: function () { return DateFilter_1.DateFilter; } });
/**
 * @beta
 */
var DateFilterHelpers = {
    validateFilterOption: OptionValidation_1.validateFilterOption,
    getDateFilterTitle: DateFilterTitle_1.getDateFilterTitle,
    getDateFilterTitleUsingTranslator: DateFilterTitle_1.getDateFilterTitleUsingTranslator,
    getDateFilterRepresentation: DateFilterTitle_1.getDateFilterRepresentation,
    granularityIntlCodes: i18n_1.granularityIntlCodes,
    applyExcludeCurrentPeriod: PeriodExclusion_1.applyExcludeCurrentPeriod,
    defaultDateFilterOptions: config_1.defaultDateFilterOptions,
    canExcludeCurrentPeriod: PeriodExclusion_1.canExcludeCurrentPeriod,
    mapOptionToAfm: AFMConversions_1.mapOptionToAfm,
    formatAbsoluteDateRange: DateFilterTitle_1.formatAbsoluteDateRange,
    formatRelativeDateRange: DateFilterTitle_1.formatRelativeDateRange,
    filterVisibleDateFilterOptions: OptionUtils_1.filterVisibleDateFilterOptions,
};
exports.DateFilterHelpers = DateFilterHelpers;
var interfaces_1 = require("./interfaces");
Object.defineProperty(exports, "isAbsoluteDateFilterOption", { enumerable: true, get: function () { return interfaces_1.isAbsoluteDateFilterOption; } });
Object.defineProperty(exports, "isRelativeDateFilterOption", { enumerable: true, get: function () { return interfaces_1.isRelativeDateFilterOption; } });
Object.defineProperty(exports, "isUiRelativeDateFilterForm", { enumerable: true, get: function () { return interfaces_1.isUiRelativeDateFilterForm; } });
var config_2 = require("./constants/config");
Object.defineProperty(exports, "defaultDateFilterOptions", { enumerable: true, get: function () { return config_2.defaultDateFilterOptions; } });
//# sourceMappingURL=index.js.map